import type { loader } from '~/root'
import { SerializeFrom } from './utils/serialize-from'

/**
 * This is a proxy which will use window.ENV when available and otherwise will use process.env
 */
export const ENV = new Proxy(
  {},
  {
    get(target, p) {
      // You can only access clientSideEnvVars via this abstraction.
      return typeof window !== 'undefined' ? (window.ENV ? window.ENV[p as string] : undefined) : process.env[p as string]
    }
  }
) as SerializeFrom<typeof loader>['env']
